/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.esp.sync.rpc.FormSubscriptionsRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './FormSubscriptionsRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.esp.sync.rpc.FormSubscriptionsRpc#getSubscriptions
 */
export const GET_SUBSCRIPTIONS_QUERY_FIELD_NAME = 'com_hubspot_esp_sync_rpc_FormSubscriptionsRpc_getSubscriptions';
export const GET_SUBSCRIPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUBSCRIPTIONS_QUERY_FIELD_NAME,
  args: ['formGuid'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getSubscriptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.esp.sync.rpc.FormSubscriptionsRpc#getSubscriptionStatus
 */
export const GET_SUBSCRIPTION_STATUS_QUERY_FIELD_NAME = 'com_hubspot_esp_sync_rpc_FormSubscriptionsRpc_getSubscriptionStatus';
export const GET_SUBSCRIPTION_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUBSCRIPTION_STATUS_QUERY_FIELD_NAME,
  args: ['formGuid'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getSubscriptionStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.esp.sync.rpc.FormSubscriptionsRpc#getBatchStatuses
 */
export const GET_BATCH_STATUSES_QUERY_FIELD_NAME = 'com_hubspot_esp_sync_rpc_FormSubscriptionsRpc_getBatchStatuses';
export const GET_BATCH_STATUSES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BATCH_STATUSES_QUERY_FIELD_NAME,
  args: ['formGuids'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getBatchStatusesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.esp.sync.rpc.FormSubscriptionsRpc#bulkUpdateSubscriptions
 */
export const BULK_UPDATE_SUBSCRIPTIONS_MUTATION_FIELD_NAME = 'com_hubspot_esp_sync_rpc_FormSubscriptionsRpc_bulkUpdateSubscriptions';
export const BULK_UPDATE_SUBSCRIPTIONS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: BULK_UPDATE_SUBSCRIPTIONS_MUTATION_FIELD_NAME,
  args: ['subscriptions'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.bulkUpdateSubscriptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.esp.sync.rpc.FormSubscriptionsRpc#createSubscription
 */
export const CREATE_SUBSCRIPTION_MUTATION_FIELD_NAME = 'com_hubspot_esp_sync_rpc_FormSubscriptionsRpc_createSubscription';
export const CREATE_SUBSCRIPTION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_SUBSCRIPTION_MUTATION_FIELD_NAME,
  args: ['formId', 'conversionId', 'formType', 'ingestionTimestamp', 'contactValues'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.createSubscriptionRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});